import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject, EMPTY } from 'rxjs';
import { DataApiService } from 'app/services/data-api.service';
import { MensajesHttpService } from 'app/utils/mensajesHttp/mensajes-http.service';
import { ToastrServiceLocal } from 'app/services/toast/toastr.service';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError, finalize, tap } from 'rxjs/operators';
import { DataApi } from 'app/Model/dataApi';
import { usuarioInterface } from '../../../Model/Administracion/usuarios.Interface';

@Injectable({
  providedIn: 'root'
})
export class UsuariosFacadeService {

  constructor(private _dataApi: DataApiService, private _mensajesHttp: MensajesHttpService,
    private _toast: ToastrServiceLocal) { }

  //Respuesta Acción
  private Action$ = new Subject<any>();
  public responseAction$: Observable<any> = this.Action$.asObservable();

  private Usuarios$ = new BehaviorSubject<usuarioInterface[]>([]);
  public responseUsuarios$: Observable<usuarioInterface[]> = this.Usuarios$.asObservable();

  private DataUsuario: any;


  private Cargando$ = new BehaviorSubject<boolean>(false);
  public responseCargando$: Observable<boolean> = this.Cargando$.asObservable();

  private Error$ = new BehaviorSubject<any>({ hasError: true, recurso: '', messageError: '', errors: [] });
  public responseError$: Observable<any> = this.Error$.asObservable();

  public Carreras$ = new BehaviorSubject<any[]>([]);
  public responseCarreras$: Observable<any[]> = this.Carreras$.asObservable();


  public Centros$ = new BehaviorSubject<any[]>([]);
  public responseCentros$: Observable<any[]> = this.Centros$.asObservable();


  public Generos$ = new BehaviorSubject<any[]>([]);
  public responseGeneros$: Observable<any[]> = this.Generos$.asObservable();


  public Identificacion$ = new BehaviorSubject<any[]>([]);
  public responseIdentificacion$: Observable<any[]> = this.Identificacion$.asObservable();


  public Perfiles$ = new BehaviorSubject<any[]>([]);
  public responsePerfiles$: Observable<any[]> = this.Perfiles$.asObservable();

  public UserEmpleado$ = new BehaviorSubject<any[]>([]);
  public responseUserEmpleado$: Observable<any[]> = this.UserEmpleado$.asObservable();

  public UserCentroCarreraAsociada$ = new BehaviorSubject<any[]>([]);
  public responseUserCentroCarreraAsociada$: Observable<any[]> = this.UserCentroCarreraAsociada$.asObservable();

  public DatosUsuarioEdit$ = new BehaviorSubject<any[]>([]);
  public responseDatosUsuarioEdit$: Observable<any[]> = this.DatosUsuarioEdit$.asObservable();




  viewMenus(params: any){

    this.Cargando$.next(true);
 
    const request$ = this._dataApi.GetDataApi(`seguridad/viewUsuarios`, params).pipe(
      tap((result: DataApi | any) => {
  
        if( result.hasError === false ){
          this.Usuarios$.next(result?.data?.Table0);
        }
  
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
  
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar los postgrados', '');
        this.Cargando$.next(false);
  
        return EMPTY;
      })
    );
  
    return request$.subscribe();
  
  }


  
  viewCarrerasPerfiles( params): Observable<any> {
  this.Cargando$.next(true); 
  const request$ = this._dataApi.GetDataApi(`seguridad/viewCarrerasPerfiles`, params).pipe(
      tap((result: DataApi | any) => {
          // this.Carreras$.next(result.data.Table0);  
          this.Centros$.next(result.data.Table0);  
          this.Generos$.next(result.data.Table1); 
          this.Identificacion$.next(result.data.Table2); 
          this.Perfiles$.next(result.data.Table3); 

          this.Cargando$.next(false);  
      }),
      catchError((error: HttpErrorResponse) => {
          console.error(error);
          this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al mostrar las promociones', '');
          this.Cargando$.next(false);  
          this.Error$.next({
              hasError: true,
              recurso: 'GET',
              messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrió un error al mostrar las promociones'),
              errors: []
          });
          return EMPTY;
      }),
      finalize(() => {
           this.Cargando$.next(false);
      })
  );

  return request$;  
}


viewCarrerasbyCentroPerfiles(idCentro, params): Observable<any> {
  this.Cargando$.next(true); 
  const request$ = this._dataApi.GetDataApi(`seguridad/viewCarrerasbyCentroPerfiles/${idCentro}`, params).pipe(
      tap((result: DataApi | any) => {
          this.Carreras$.next(result.data.Table0);  

          this.Cargando$.next(false);  
      }),
      catchError((error: HttpErrorResponse) => {
          console.error(error);
          this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al mostrar las promociones', '');
          this.Cargando$.next(false);  
          this.Error$.next({
              hasError: true,
              recurso: 'GET',
              messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrió un error al mostrar las promociones'),
              errors: []
          });
          return EMPTY;
      }),
      finalize(() => {
           this.Cargando$.next(false);
      })
  );

  return request$;  
}



//insertar usuario

insertUsuario(params: any) {
  this.Action$.next({});
  this.Cargando$.next(true);
  this._toast.mensajeLoading('Cargando', 'Procesando la información');

  const request$ = this._dataApi.PostDataApi(`seguridad/registroUsuario`, params).pipe(
    tap((result: DataApi | any) => {
      console.log(result);
      this._toast.clearToasts();
      this.Usuarios$.next(result.data.Table1);
      this.Cargando$.next(false);
      this.Action$.next(result);
      this._toast.mensajeSuccess(result.data.Table0[0]?.mensaje, 'Guardado');

    }),
    catchError((error: HttpErrorResponse) => {
      console.log(error);
      this._toast.clearToasts();
      this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al guardar la solicitud', '');
      this.Cargando$.next(false);
      return EMPTY;
    })
  );
  return request$;  
}


//update usuario

updateDatosUsuario(params: any) {
  this.Action$.next({});
  this.Cargando$.next(true);
  this._toast.mensajeLoading('Cargando', 'Procesando la información');

  const request$ = this._dataApi.PutDataApi(`seguridad/actualizarUsuarioAdministrativo`, params).pipe(
    tap((result: DataApi | any) => {
      console.log(result);
      this._toast.clearToasts();
      this.Usuarios$.next(result?.data?.Table1);
            this.Cargando$.next(false);
      this.Action$.next(result);
      this._toast.mensajeSuccess(result.data.Table0[0]?.mensaje, 'Guardado');

    }),
    catchError((error: HttpErrorResponse) => {
      console.log(error);
      this._toast.clearToasts();
      this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al guardar la solicitud', '');
      this.Cargando$.next(false);
      return EMPTY;
    })
  );
  return request$;  
}





verUserEmpleado(CodEmpleado: any, params): Observable<any> {
  this.Cargando$.next(true);  
  const request$ = this._dataApi.GetDataApi(`seguridad/viewEmpleado/${CodEmpleado}`, params).pipe(
      tap((result: DataApi | any) => {
          this.UserEmpleado$.next(result.data.Table0);  
          this.Cargando$.next(false);  
      }),
      catchError((error: HttpErrorResponse) => {
          console.error(error);
          this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al mostrar las promociones', '');
          this.Cargando$.next(false);  
          this.UserEmpleado$.next([]); 
          this.Error$.next({
              hasError: true,
              recurso: 'GET',
              messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrió un error al mostrar las promociones'),
              errors: []
          });
          return EMPTY;
      }),
      finalize(() => {
           this.Cargando$.next(false);
      })
  );

  return request$; 
}


verUserEmpleadoContrato(CodEmpleado: any, params): Observable<any> {
  this.Cargando$.next(true);  
  const request$ = this._dataApi.GetDataApi(`seguridad/viewEmpleadoContrato/${CodEmpleado}`, params).pipe(
      tap((result: DataApi | any) => {
          this.UserEmpleado$.next(result.data.Table0);  
          this.Cargando$.next(false);  
      }),
      catchError((error: HttpErrorResponse) => {
          console.error(error);
          this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al mostrar las promociones', '');
          this.Cargando$.next(false);  
          this.UserEmpleado$.next([]); 
          this.Error$.next({
              hasError: true,
              recurso: 'GET',
              messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrió un error al mostrar las promociones'),
              errors: []
          });
          return EMPTY;
      }),
      finalize(() => {
           this.Cargando$.next(false);
      })
  );

  return request$; 
}


verCentroCarreraAsociada(idUsuarioAsociado: any, params): Observable<any> {
  this.Cargando$.next(true);  
  const request$ = this._dataApi.GetDataApi(`seguridad/viewCentroCarreraAsociada/${idUsuarioAsociado}`, params).pipe(
      tap((result: DataApi | any) => {
          this.UserCentroCarreraAsociada$.next(result.data.Table0);  
          this.Cargando$.next(false);  
      }),
      catchError((error: HttpErrorResponse) => {
          console.error(error);
          this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al mostrar las promociones', '');
          this.Cargando$.next(false);  
          this.UserCentroCarreraAsociada$.next([]); 
          this.Error$.next({
              hasError: true,
              recurso: 'GET',
              messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrió un error al mostrar las promociones'),
              errors: []
          });
          return EMPTY;
      }),
      finalize(() => {
           this.Cargando$.next(false);
      })
  );

  return request$; 
}


// ver datos para edicion
VerdatosUsuarioSeguridad(idUsuarioAsociado: any, params): Observable<any> {
  this.Cargando$.next(true);  
  const request$ = this._dataApi.GetDataApi(`seguridad/viewVerdatosUsuarioSeguridad/${idUsuarioAsociado}`, params).pipe(
      tap((result: DataApi | any) => {
          this.DatosUsuarioEdit$.next(result.data.Table0);  
          this.Cargando$.next(false);  
      }),
      catchError((error: HttpErrorResponse) => {
          console.error(error);
          this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al mostrar las promociones', '');
          this.Cargando$.next(false);  
          this.DatosUsuarioEdit$.next([]); 
          this.Error$.next({
              hasError: true,
              recurso: 'GET',
              messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrió un error al mostrar las promociones'),
              errors: []
          });
          return EMPTY;
      }),
      finalize(() => {
           this.Cargando$.next(false);
      })
  );

  return request$; 
}


  MostrarUsuarios(params: any) {
    this.Cargando$.next(true);
    const request$ = this._dataApi.PostDataApi('admin/v1/usuarioMostrar', params, true).pipe(
      tap((result: DataApi | any) => {
        // console.log(result);
        this.Usuarios$.next(result?.data?.Table0);
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this.Action$.next({});
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar los usuarios', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'PUT', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un error al mostrar los usuarios'), errors: [] });
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  NuevoUsuario(params: any) {
    this.Cargando$.next(true);
    this._toast.mensajeLoading('Cargando', 'Procesando la información');

    const request$ = this._dataApi.PostDataApi('admin/v1/usuario', params, true).pipe(
      tap((result: DataApi | any) => {
        this._toast.clearToasts();

        this.Action$.next(result);
        this._toast.mensajeSuccess('Se inserto con éxito el usuario', '');
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this._toast.clearToasts();

        this.Action$.next({});
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al insertar el usuario', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'PUT', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un error al insertar el usuario'), errors: [] });
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  ActualizarUsuario(params: any) {
    this.Cargando$.next(true);
    this._toast.mensajeLoading('Cargando', 'Procesando la información');

    const request$ = this._dataApi.PutDataApi('admin/v1/usuario', params, true).pipe(
      tap((result: DataApi | any) => {
        this._toast.clearToasts();

        this.Action$.next(result);
        this._toast.mensajeSuccess('Se actualizó con éxito el usuario', '');
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this._toast.clearToasts();

        this.Action$.next({});
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al actualizar el usuario', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'PUT', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un error al actualizar el usuario'), errors: [] });
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  UsuarioMenuActualizar(params: any) {
    this.Cargando$.next(true);
    this._toast.mensajeLoading('Cargando', 'Procesando la información');

    const request$ = this._dataApi.PostDataApi('admin/v1/usuario/asignarMenu', params, true).pipe(
      tap((result: DataApi | any) => {
        this._toast.clearToasts();

        this.Action$.next(result);
        this.Cargando$.next(false);
        this._toast.mensajeSuccess('Se actualizó con éxito los permisos del menú', '');

      }),
      catchError((error: HttpErrorResponse) => {
        this._toast.clearToasts();

        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al actualizar los permisos del menú', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'GET', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un error al actualizar los permisos del menu'), errors: [] });
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  UsuarioEliminar(params: any) {
    this.Cargando$.next(true);
    this._toast.mensajeLoading('Cargando', 'Procesando la información');

    const request$ = this._dataApi.DeleteDataApi('admin//v1/usuario', params, true).pipe(
      tap((result: DataApi | any) => {
        this._toast.clearToasts();

        this.Action$.next(result);
        this._toast.mensajeSuccess('Se eliminó con éxito el usuario', '');
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this._toast.clearToasts();

        this.Action$.next({});
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar el usuario', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'PUT', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un error al eliminar el usuario'), errors: [] });
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  UsuarioPerfilIngresar(params: any) {
    this.Cargando$.next(true);
    this._toast.mensajeLoading('Cargando', 'Procesando la información');
    const request$ = this._dataApi.PostDataApi('admin/v1/usuario/perfil', params, true).pipe(
      tap((result: DataApi | any) => {
        this._toast.clearToasts();

        this.Action$.next(result);
        this._toast.mensajeSuccess('Se inserto con éxito el perfil al usuario', '');
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this._toast.clearToasts();

        this.Action$.next({});
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al insertar el perfil', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'PUT', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un error al insertar el perfil'), errors: [] });
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  SetearUsuario(item) {
    this.DataUsuario = item;
  }

  consumirUsuario() {
    return this.DataUsuario;
  }
}
